/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<e9bdb29941746b418be53d413ca3b31b>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType40 = {
  getVariation: function getVariation(n) {
    if (n === 1) {
      return IntlVariations.NUMBER_ONE;
    } else if (n === 2) {
      return IntlVariations.NUMBER_TWO;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType40;